import { render } from "./ApprovalPending.vue?vue&type=template&id=ade02002&scoped=true"
import script from "./ApprovalPending.vue?vue&type=script&lang=js"
export * from "./ApprovalPending.vue?vue&type=script&lang=js"

import "./ApprovalPending.vue?vue&type=style&index=0&id=ade02002&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ade02002"]])

export default __exports__